/** Centralized application route paths. */

export const ROUTES = {
  // Public
  LOGIN: '/login',
  FORBIDDEN: '/403',

  // App
  ROOT: '/',
  DASHBOARD: '/dashboard',

  // Pipeline
  STAGE1: '/stage1',
  STAGE2: '/stage2',
  BRIEFING: '/briefing',
  STORAGE1: '/storage1',
  STORAGE2: '/storage2',
  OCR_STORAGE: '/ocr-storage',
  NO_STORAGE: '/no-storage',

  // Search
  SEARCH: '/search',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_NEWSPAPERS: '/settings/newspapers',
  SETTINGS_ROLES: '/settings/roles',
  SETTINGS_ROLE_DETAIL: '/settings/roles/:id',
  SETTINGS_USERS: '/settings/users',
  SETTINGS_USER_DETAIL: '/settings/users/:id',
  SETTINGS_ACTIVITY_LOGS: '/settings/activity-logs',
  SETTINGS_SYSTEM_CONFIG: '/settings/system-configuration',
};

/** Build a concrete path from a parametrized route template. */
export const buildPath = (template, params = {}) =>
  Object.entries(params).reduce(
    (path, [key, value]) => path.replace(`:${key}`, encodeURIComponent(value)),
    template
  );

export default ROUTES;
